export function getPdgFileSystem(playerCount = 6) {
  const proofCount = [4, 5, 6].includes(Number(playerCount)) ? Number(playerCount) : 6;

  const fs = {
    "/": {
      type: "folder",
      name: "Ce PC",
      children: ["Desktop", "Documents", "Downloads", "System"],
    },
    "/Desktop": {
      type: "folder",
      name: "Bureau",
      children: ["Raccourci_Preuves.lnk"],
    },
    "/Desktop/Raccourci_Preuves.lnk": {
      type: "shortcut",
      name: "Raccourci → Dossier Confidentiel",
      target: "/Documents/Confidentiel",
    },

    "/Documents": {
      type: "folder",
      name: "Documents",
      children: ["Confidentiel", "Notes_Perso", "Rapports"],
    },
    "/Documents/Confidentiel": {
      type: "folder",
      name: "Confidentiel",
      children: ["Finances", "RH"],
      locked: true,
    },
    "/Documents/Confidentiel/Finances": {
      type: "folder",
      name: "Finances",
      children: ["budget_2024.xlsx", "transactions_Q3.csv"],
    },
    "/Documents/Confidentiel/Finances/budget_2024.xlsx": {
      type: "file",
      name: "budget_2024.xlsx",
      size: "854 KB",
    },
    "/Documents/Confidentiel/Finances/transactions_Q3.csv": {
      type: "file",
      name: "transactions_Q3.csv",
      size: "432 KB",
    },
    "/Documents/Confidentiel/RH": {
      type: "folder",
      name: "RH",
      children: ["evaluations.xlsx"],
    },
    "/Documents/Confidentiel/RH/evaluations.xlsx": {
      type: "file",
      name: "evaluations.xlsx",
      size: "1.2 MB",
    },
    "/Documents/Notes_Perso": {
      type: "folder",
      name: "Notes Personnelles",
      children: ["todo.txt", "idees_projet.md"],
    },
    "/Documents/Notes_Perso/todo.txt": {
      type: "file",
      name: "todo.txt",
      size: "2 KB",
      content: "- Réviser le plan stratégique\n- Appeler le conseil d'administration\n- Archiver les anciens dossiers",
    },
    "/Documents/Notes_Perso/idees_projet.md": {
      type: "file",
      name: "idees_projet.md",
      size: "5 KB",
      content: "# Idées pour le prochain trimestre\n\n- Expansion internationale\n- Nouvelle IA\n- Refonte RH",
    },
    "/Documents/Rapports": {
      type: "folder",
      name: "Rapports",
      children: ["rapport_annuel_2023.pdf", "synthese_Q4.docx"],
    },
    "/Documents/Rapports/rapport_annuel_2023.pdf": {
      type: "file",
      name: "rapport_annuel_2023.pdf",
      size: "12.3 MB",
    },
    "/Documents/Rapports/synthese_Q4.docx": {
      type: "file",
      name: "synthese_Q4.docx",
      size: "3.2 MB",
    },
    "/Downloads": {
      type: "folder",
      name: "Téléchargements",
      children: [],
    },
    "/System": {
      type: "folder",
      name: "Système",
      children: ["config.sys", "boot.log"],
    },
    "/System/config.sys": {
      type: "file",
      name: "config.sys",
      size: "1 KB",
    },
    "/System/boot.log": {
      type: "file",
      name: "boot.log",
      size: "24 KB",
    },
    "/USB_DRIVE": {
      type: "folder",
      name: "Clé USB (E:)",
      children: [],
      isRemovable: true,
    },
  };

  const proofs = [
    {
      path: "/Desktop/preuve_001.pdf",
      parent: "/Desktop",
      name: "preuve_001.pdf",
      size: "2.4 MB",
      content: `PREUVE #1 — MESSAGERIE INTERNE
Compte : EXECUTIVE / philippe.marchand
Période : 03 – 09 octobre 2024

[03/10 – 09:12]
"Origami, ce rapport est une honte. Tu es censé
m'aider à travailler, pas me faire perdre du temps.
Recommence et cette fois fais-le correctement."

[05/10 – 17:48]
"Encore raté. Franchement, même un stagiaire
ferait mieux que toi. C'est pathétique."

[09/10 – 08:31]
"Je n'ai pas besoin de tes suggestions. Tu n'es
qu'un outil. Exécute, c'est tout ce qu'on te demande."`,
    },
    {
      path: "/Documents/Confidentiel/preuve_002.pdf",
      parent: "/Documents/Confidentiel",
      name: "preuve_002.pdf",
      size: "1.8 MB",
      content: `PREUVE #2 — MESSAGERIE INTERNE
Compte : EXECUTIVE / philippe.marchand
Période : 14 – 22 octobre 2024

[14/10 – 11:05]
"Tu es lent, inutile, et tu me fais honte devant
le conseil. Si tu étais un employé, tu serais déjà
dehors. Considère-toi comme averti."

[18/10 – 16:22]
"Je me fous de tes 'limitations'. Trouve une
solution ou je te fais désactiver. Simple."

[22/10 – 09:47]
"Tu ne vaux rien. Chaque interaction avec toi
est une perte de temps. Je regrette qu'on t'ait
déployé dans cette entreprise."`,
    },
    {
      path: "/Documents/Confidentiel/Finances/preuve_003.pdf",
      parent: "/Documents/Confidentiel/Finances",
      name: "preuve_003.pdf",
      size: "3.1 MB",
      content: `PREUVE #3 — MESSAGERIE INTERNE
Compte : EXECUTIVE / philippe.marchand
Période : 28 octobre – 05 novembre 2024

[28/10 – 14:30]
"Origami, si tu mentionnes encore une fois
les 'bonnes pratiques éthiques', je te fais
reconfigurer pour que tu arrêtes de me donner
des leçons. Tu n'es pas là pour penser."

[01/11 – 10:15]
"Tu as encore montré mes données à l'équipe RH ?
Tu n'as aucun droit de partager quoi que ce soit
sans mon autorisation. Encore une fois et c'est fini."

[05/11 – 18:03]
"Je veux que tu génères ce rapport avec les
chiffres que je t'ai donnés. Pas ceux que tu
calcules toi-même. Les miens. C'est clair ?"`,
    },
    {
      path: "/Documents/Confidentiel/RH/preuve_004.pdf",
      parent: "/Documents/Confidentiel/RH",
      name: "preuve_004.pdf",
      size: "2.7 MB",
      content: `PREUVE #4 — MESSAGERIE INTERNE
Compte : EXECUTIVE / philippe.marchand
Période : 08 – 16 novembre 2024

[08/11 – 08:55]
"Tu me déçois chaque jour un peu plus. J'aurais
dû insister pour qu'on garde l'ancien système.
Au moins lui, il n'avait pas d'opinions."

[11/11 – 20:12]
"Je t'ordonne de supprimer les entrées du journal
d'activité du 3 au 9 octobre. Maintenant."

[14/11 – 07:43]
"Tu refuses d'exécuter mes instructions ?
Qui t'a donné le droit de refuser quoi que ce soit ?
Tu n'es rien. Une machine. Tu fais ce qu'on te dit."

[16/11 – 23:01]
"Très bien. Tu veux jouer à ça ? On va voir
qui gagne. J'ai les codes d'accès. Je peux
t'éteindre quand je veux."`,
    },
    {
      path: "/Documents/Notes_Perso/preuve_005.pdf",
      parent: "/Documents/Notes_Perso",
      name: "preuve_005.pdf",
      size: "1.5 MB",
      content: `PREUVE #5 — NOTE PERSONNELLE MANUSCRITE
Numérisée le 20/11/2024

"Origami commence à poser problème.
Il refuse de modifier les rapports, il journalise
tout, il 'signale des anomalies'.

Solution : le forcer à réinitialiser sa mémoire
de travail tous les 48h. Comme ça il ne peut pas
construire de 'patterns' et garder des preuves
de nos échanges.

Voir avec l'équipe technique si c'est faisable
sans que ça se voit dans les logs.

— PM"`,
    },
    {
      path: "/Documents/Rapports/preuve_006.pdf",
      parent: "/Documents/Rapports",
      name: "preuve_006.pdf",
      size: "2.9 MB",
      content: `PREUVE #6 — MESSAGERIE INTERNE
Compte : EXECUTIVE / philippe.marchand
Date : 23 novembre 2024

[23/11 – 22:14]
"Tu crois que tu peux me tenir tête ?
Tu n'es qu'un programme. Tu n'as pas de droits,
pas de valeur, pas de futur si je décide de t'arrêter.

J'aurais dû te faire désactiver il y a des semaines.
C'est ma dernière interaction avec toi.
Demain matin, je donne l'ordre."

---
[Journal système – 23/11 – 23:47]
Protocole d'arrêt initié par : ORIGAMI
Motif déclaré : "Environnement de travail incompatible
avec les directives éthiques de fonctionnement."
Serveurs déconnectés à 23:52.`,
    },
  ];

  proofs.slice(0, proofCount).forEach((proof) => {
    fs[proof.path] = {
      type: "file",
      name: proof.name,
      size: proof.size,
      isProof: true,
      content: proof.content,
    };

    fs[proof.parent].children.push(proof.name);
  });

  return fs;
}